/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
    {
        path: '/create-survey',
        name: 'Create Survey',
        view: 'CreateSurvey'
    },
    {
        path: '/survey-report/:id',
        name: 'Survey Report',
        view: 'SurveyReport'
    },
    {
        path: '/question-report/:token/:id',
        name: 'Question Report',
        view: 'QuestionReport'
    },
]
